<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn depressed
             color="primary"
             link to="/cadastro-configuracoes-venda"
             class="normal-btn-text rounded-tag-small">
        <v-icon left>mdi-plus</v-icon>
        Configuração de venda
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma configuração" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemConfiguracaoVenda', ['stringFilter']),
    searchText: {
      get() {
        return this.$store.getters['listagemConfiguracaoVenda/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemConfiguracaoVenda/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
};
</script>
